import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveSchoolDataThunk } from "../../../../shared/store/redux/auth-actions";
import SaveButton from "../shared/saveButton/SaveButton";
import ImageUpload from "../../../../shared/components/ui/imageUpload/ImageUpload";
import classes from "./SchoolLogoSection.module.css";

const SchoolLogoSection = () => {

    const { texts } = useSelector((state) => state.translate);
    const { loading } = useSelector((state) => state.auth);
    const [iconFile, setIconFile] = useState();
    const schoolData = useSelector((state) => state.auth?.userDetails?.defaultSchool);
    const dispatch = useDispatch();

    const hasChanges = () => {
        return iconFile !== undefined;
    }

    const buildFormData = () => {
        const formData = new FormData();
        formData.append("schoolId", schoolData?.id);

        if (iconFile instanceof File)
            formData.append("iconFile", iconFile);
        else
            formData.append("iconUrl", iconFile === null ? "" : schoolData?.iconUrl ?? "");

        formData.append("imageUrl", schoolData?.imageUrl ?? "");
        formData.append("imageLink", schoolData?.imageLink ?? "");
        return formData;
    };

    const handleSave = async () => {
        if (!schoolData?.id) return;
        const result = await dispatch(saveSchoolDataThunk(buildFormData()));
        if (result) {
            setIconFile(undefined);
        }
    };

    const handleLogoDelete = () => {
        setIconFile(null);
    };

    return (
        <div className={classes.Section}>
            <h2 className={classes.SectionTitle}>{texts.schoolLogoTitle}</h2>
            <ImageUpload
                    imageFile={iconFile === undefined ? schoolData?.iconUrl ?? null : iconFile}
                    onImageChange={setIconFile}
                    onRemove={handleLogoDelete}
                    removeAriaLabel={texts.delete}
                    maxSizeBytes={100 * 1024}
                    bannerKey="imageUploadDimensions"
                    size={107}
                />

            <SaveButton
                onClick={handleSave}
                disabled={!hasChanges() || loading}
            />
        </div>
    );
};

export default SchoolLogoSection;
